export enum DisciplineColors {
    BROWN = '#664B41',
    PURPLE = '#9C27B0',
    PINK = '#E91E63',
    INDIGO = '#3F51B5',
    DEEP_ORANGE = '#FF5722',
    BLUE = '#2196F3',
    GREEN = '#4CAF50',
}

export const DISCIPLINE_COLOR_PALETTE = Object.values(DisciplineColors);

// https://en.wikipedia.org/wiki/Golden_angle
// Stepping the hue by this angle each index spreads successive colors as far apart on
// the color wheel as possible, so even a long sequence of disciplines stays distinct.
const GOLDEN_ANGLE = 137.508;

// The first colors come from the defined palette; past it, the hue steps by the
// golden angle so any number of disciplines stay visually distinct.
export const disciplineColorForIndex = (index: number): string => {
    if (index < DISCIPLINE_COLOR_PALETTE.length) {
        return DISCIPLINE_COLOR_PALETTE[index];
    }
    return `hsl(${((index * GOLDEN_ANGLE) % 360).toFixed(1)}, 65%, 55%)`;
};
